import { Controller } from '@hotwired/stimulus'
import '../../../css/log/log.scss'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'
import tooltip from 'bootstrap/js/dist/tooltip'
import { getTimeFormat } from '../../utils/utils'
import { dispatchCustomEvent } from '../../modules/utils/DispatchCustomEvent'
import { trans, PLURAL_DAYS, PLURAL_HOURS, PLURAL_MINUTES } from '../../translator'

global.moment = require('moment')
require('tempusdominus-bootstrap-4')
$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'far fa-arrow-up',
    down: 'far fa-arrow-down',
    previous: 'far fa-chevron-left',
    next: 'far fa-chevron-right',
    today: 'far fa-calendar-check-o',
    clear: 'far fa-trash',
    close: 'far fa-check'
  }
})

export default class extends Controller {
  static targets = [
    'logEventSelect', 'logEventMenu', 'logEventTimingSelect', 'logRelativeEventSelect', 'logRelativeEventMenu', 'logEventTimeSelect', 'logEventTimeInput', 'logEventTimeInfo',
    'logRelativeTimingGroup', 'logRelativeTimingInput',
    'incomplete'
  ]

  get logTimingsController () {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('[data-controller="log-timings"]'), 'log-timings')
  }

  get logController () {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('[data-controller="log"]'), 'log')
  }

  connect () {
    $('[data-toggle="tooltip"]').tooltip()

    $(this.logEventSelectTarget).dropdown({
      forceSelection: false,
      onChange: (value, text) => {
        this.element.dataset.timingId = value
        dispatchCustomEvent('timings:timing:added', {
          timingId: value,
          timingName: text,
          isApplyToAllDays: document.querySelector('#applyTimingsToAllDaysInput') ? document.querySelector('#applyTimingsToAllDaysInput').checked : false,
          day: this.element.closest('.timing-group').dataset.day
        })

        this.logTimingsController.disableEventDropdownOptions(value)
        this.logTimingsController.enableEventDropdownOptions(this.element.dataset.previousTimingId)

        if (value !== this.element.dataset.previousTimingId) {
          const newItem = '<div class="item" data-value="' + value + '">' + text + '</div>'
          this.logTimingsController.addToRelatedEventDropdowns(value, newItem)
          this.logTimingsController.removeFromRelatedEventDropdowns(this.element.dataset.previousTimingId)
          this.logTimingsController.clearRelatedEventDropdowns(this.element.dataset.previousTimingId)

          this.element.dataset.previousTimingId = value
        }

        this.logTimingsController.calculateAllOccursAt()
      }
    })

    $(this.logEventTimingSelectTarget).dropdown({
      onChange: value => {
        if (value === 'at') {
          this.element.dataset.isAbsolute = true
          this.element.dataset.isRelative = false

          if (this.element.dataset.timingId) {
            this.element.dataset.previousTimingId = this.element.dataset.timingId

            const newItem = '<div class="item" data-value="' + this.element.dataset.timingId + '">' + $(this.logEventSelectTarget).dropdown('get text') + '</div>'
            this.logTimingsController.addToRelatedEventDropdowns(this.element.dataset.timingId, newItem)
          }

          this.hideRelativeTimingInputs()
          this.showAbsoluteTimingInputs()
        } else {
          this.element.dataset.isAbsolute = false
          this.element.dataset.isRelative = true

          if (this.element.dataset.timingId) {
            this.element.dataset.previousTimingId = this.element.dataset.timingId

            const newItem = '<div class="item" data-value="' + this.element.dataset.timingId + '">' + $(this.logEventSelectTarget).dropdown('get text') + '</div>'
            this.logTimingsController.addToRelatedEventDropdowns(this.element.dataset.timingId, newItem)
          }

          if (value === 'after') {
            this.element.dataset.relativeTimingType = 'after'
          } else if (value === 'before') {
            this.element.dataset.relativeTimingType = 'before'
          }

          this.hideAbsoluteTimingInputs()
          this.showRelativeTimingInputs()
        }

        this.logTimingsController.calculateAllOccursAt()
      }
    })

    $(this.logEventTimeSelectTarget).datetimepicker({
      focusOnShow: false,
      toolbarPlacement: 'bottom',
      format: getTimeFormat(accountIsUseAmPm),
      buttons: {
        showClose: true,
        showClear: true
      }
    })

    $(this.logEventTimeSelectTarget).off('hide.datetimepicker').on('hide.datetimepicker', () => {
      this.showHideAbsoluteTimingInfo()
      this.calculateOccursAt()
      this.logTimingsController.calculateAllOccursAt()
    })

    this.handleBlur = this.handleBlur.bind(this)
    this.logRelativeTimingInputTargets.forEach(input => {
      input.removeEventListener('blur', this.handleBlur)
      input.addEventListener('blur', this.handleBlur)
    })

    $(this.logRelativeEventSelectTarget).dropdown({
      forceSelection: false,
      onChange: (value) => {
        if (value) {
          this.element.dataset.relativeTimingId = value
        } else {
          delete this.element.dataset.relativeTimingId
        }

        this.logTimingsController.calculateAllOccursAt()
      }
    })
  }

  disconnect () {
    this.logRelativeTimingInputTargets.forEach(input => {
      input.removeEventListener('blur', this.handleBlur)
    })
  }

  handleBlur (event) {
    const unitKeys = {
      plural_days: PLURAL_DAYS,
      plural_hours: PLURAL_HOURS,
      plural_minutes: PLURAL_MINUTES
    }
    const input = event.target
    const value = parseInt(input.value)
    if (value < input.min) {
      input.value = input.min
    } else if (value > input.max) {
      input.value = input.max
    }

    const unitElement = input.nextElementSibling
    const unitName = unitElement.dataset.localiseKey
    const unitKey = unitKeys[unitName]
    unitElement.textContent = trans(unitKey, { '%value%': value }, 'logs')

    this.logTimingsController.calculateAllOccursAt()
  }

  calculateOccursAt () {
    delete this.element.dataset.occursAtInMinutes

    if (this.element.dataset.isAbsolute === 'true') {
      if (this.logEventTimeSelectTarget.querySelector('input.datetimepicker-input').value) {
        const [hours, minutes] = $(this.logEventTimeSelectTarget).datetimepicker('viewDate').format('HH:mm').split(':').map(Number)
        this.element.dataset.occursAtInMinutes = (hours * 60) + minutes
      }
    } else if (this.element.dataset.isRelative === 'true') {
      const invert = this.element.dataset.relativeTimingType === 'before' ? -1 : 1
      const [relativeDays, relativeHours, relativeMinutes] = this.logRelativeTimingInputTargets.map(target => (parseInt(target.value) || 0) * invert)

      const daysInMinutes = relativeDays * 24 * 60
      const hoursInMinutes = relativeHours * 60
      this.element.dataset.relativeOffsetInMinutes = daysInMinutes + hoursInMinutes + relativeMinutes

      if (this.element.dataset.relativeTimingId) {
        const initialTotalMinutes = this.logTimingsController.getAbsoluteTimeInMinutes(this.element.dataset.relativeTimingId)
        if (initialTotalMinutes) {
          this.element.dataset.occursAtInMinutes = initialTotalMinutes + parseInt(this.element.dataset.relativeOffsetInMinutes)
        }
      }
    }

    if (this.element.dataset.timingId && this.element.dataset.occursAtInMinutes) {
      this.element.classList.remove('error')
      this.incompleteTarget.classList.add('d-none')
    }
  }

  hideAbsoluteTimingInputs () {
    this.logEventTimeSelectTarget.classList.add('d-none')
    this.logEventTimeSelectTarget.classList.remove('d-inline')
    if (this.hasLogEventTimeInfoTarget) {
      this.logEventTimeInfoTarget.classList.add('d-none')
    }
  }

  showAbsoluteTimingInputs () {
    this.logEventTimeSelectTarget.classList.add('d-inline')
    this.logEventTimeSelectTarget.classList.remove('d-none')
    this.showHideAbsoluteTimingInfo()
  }

  showHideAbsoluteTimingInfo () {
    if (this.logEventTimeSelectTarget.querySelector('input').value) {
      if (this.hasLogEventTimeInfoTarget) {
        this.logEventTimeInfoTarget.classList.add('d-none')
      }
    } else {
      if (this.hasLogEventTimeInfoTarget) {
        this.logEventTimeInfoTarget.classList.remove('d-none')
      }
    }
  }

  hideRelativeTimingInputs () {
    this.logRelativeTimingGroupTarget.classList.add('d-none')
    this.logRelativeTimingGroupTarget.classList.remove('d-inline')
    this.logRelativeEventSelectTarget.classList.add('d-none')
    this.logRelativeTimingInputTargets.forEach(input => {
      input.value = null
    })
  }

  showRelativeTimingInputs () {
    this.logRelativeTimingGroupTarget.classList.add('d-inline')
    this.logRelativeTimingGroupTarget.classList.remove('d-none')
    this.logRelativeEventSelectTarget.classList.remove('d-none')
  }

  remove () {
    this.logTimingsController.removeFromRelatedEventDropdowns($(this.logEventSelectTarget).dropdown('get value'))
    const absoluteTimingId = $(this.logEventSelectTarget).dropdown('get value')
    if (absoluteTimingId) {
      this.logTimingsController.clearRelatedEventDropdowns(absoluteTimingId)
    }
    this.logTimingsController.enableEventDropdownOptions($(this.logEventSelectTarget).dropdown('get value'))

    dispatchCustomEvent('timings:timing:removed', {
      timingId: this.element.dataset.timingId,
      isApplyToAllDays: document.querySelector('#applyTimingsToAllDaysInput') ? document.querySelector('#applyTimingsToAllDaysInput').checked : false,
      day: this.element.closest('.timing-group').dataset.day
    })
    this.element.remove()
  }
}
